import React from "react";
import BreadCrumb from "../../../Common/BreadCrumb";
import { pricingData } from "../../../Common/data";
import { Link } from "react-router-dom";

const Pricing = () => {
  return (
    <React.Fragment>
      <BreadCrumb title="Pricing" pageType="Components" />
      <div className="flex flex-col gap-4 min-h-[calc(100vh-212px)]">
        <div className="grid grid-cols-1 gap-4">
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Pricing Plan
            </h2>
            <div className="mx-auto max-w-7xl">
              <div className="grid grid-cols-1 gap-4 lg:grid-cols-2 xl:grid-cols-3">
                {/* Pricing Cards */}
                {pricingData.map((plan: any, index: number) => (
                  <div
                    key={index}
                    className="py-10 border rounded-md border-black/10 dark:border-darkborder px-7 relative"
                  >
                    {/* Most Popular Label */}
                    {plan.isPopular && (
                      <div className="absolute top-0 inline-block gap-2 px-3 py-2 rounded-b-lg ltr:-translate-x-1/2 rtl:translate-x-1/2 bg-purple/20 text-purple ltr:left-1/2 rtl:right-1/2">
                        <p className="flex items-center">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            className="w-5 h-5"
                          >
                            <path
                              fill="currentColor"
                              d="M5 4.60434V13.7889C5 15.1263 5.6684 16.3752 6.7812 17.1171L12 20.5963L17.2188 17.1171C18.3316 16.3752 19 15.1263 19 13.7889V4.60434L12 3.04879L5 4.60434ZM3.78307 2.82598L12 1L20.2169 2.82598C20.6745 2.92766 21 3.33347 21 3.80217V13.7889C21 15.795 19.9974 17.6684 18.3282 18.7812L12 23L5.6718 18.7812C4.00261 17.6684 3 15.795 3 13.7889V3.80217C3 3.33347 3.32553 2.92766 3.78307 2.82598ZM12 13.5L9.06107 15.0451L9.62236 11.7725L7.24472 9.45492L10.5305 8.97746L12 6L13.4695 8.97746L16.7553 9.45492L14.3776 11.7725L14.9389 15.0451L12 13.5Z"
                            ></path>
                          </svg>
                          Most Popular
                        </p>
                      </div>
                    )}
                    {/* Pricing Details */}
                    <h2 className="text-6xl font-semibold dark:text-white">
                      <span className="text-lg">$</span>
                      {plan.price}
                      <span className="text-lg text-muted dark:text-darkmuted">
                        / Month
                      </span>
                    </h2>
                    <div className="py-7">
                      <h4 className="text-2xl font-semibold dark:text-white">
                        {plan.title}
                      </h4>
                      <p className="mt-2 text-muted dark:text-darkmuted">
                        {plan.description}
                      </p>
                    </div>
                    <div className="py-4">
                      <Link
                        to="#"
                        className={plan.btnClass}
                      >
                        Buy Now
                      </Link>
                    </div>
                    <div className="mt-8 space-y-4">
                      <p className="flex items-center gap-2 mt-0 text-muted dark:text-darkmuted">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          className="w-5 h-5 text-purple"
                        >
                          <path
                            fill="currentColor"
                            d="M11.602 13.7599L13.014 15.1719L21.4795 6.7063L22.8938 8.12051L13.014 18.0003L6.65 11.6363L8.06421 10.2221L10.189 12.3469L11.6025 13.7594L11.602 13.7599ZM11.6037 10.9322L16.5563 5.97949L17.9666 7.38977L13.014 12.3424L11.6037 10.9322ZM8.77698 16.5873L7.36396 18.0003L1 11.6363L2.41421 10.2221L3.82723 11.6352L3.82604 11.6363L8.77698 16.5873Z"
                          ></path>
                        </svg>
                        <span className="font-semibold text-black dark:text-white">
                          100TB
                        </span>{" "}
                        CDN Bandwidth
                      </p>
                      <p className="flex items-center gap-2 mt-0 text-muted dark:text-darkmuted">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          className="w-5 h-5 text-purple"
                        >
                          <path
                            fill="currentColor"
                            d="M11.602 13.7599L13.014 15.1719L21.4795 6.7063L22.8938 8.12051L13.014 18.0003L6.65 11.6363L8.06421 10.2221L10.189 12.3469L11.6025 13.7594L11.602 13.7599ZM11.6037 10.9322L16.5563 5.97949L17.9666 7.38977L13.014 12.3424L11.6037 10.9322ZM8.77698 16.5873L7.36396 18.0003L1 11.6363L2.41421 10.2221L3.82723 11.6352L3.82604 11.6363L8.77698 16.5873Z"
                          ></path>
                        </svg>
                        API/Formulas Support*
                      </p>
                      <p className="flex items-center gap-2 mt-0 text-muted dark:text-darkmuted">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          className="w-5 h-5 text-purple"
                        >
                          <path
                            fill="currentColor"
                            d="M11.602 13.7599L13.014 15.1719L21.4795 6.7063L22.8938 8.12051L13.014 18.0003L6.65 11.6363L8.06421 10.2221L10.189 12.3469L11.6025 13.7594L11.602 13.7599ZM11.6037 10.9322L16.5563 5.97949L17.9666 7.38977L13.014 12.3424L11.6037 10.9322ZM8.77698 16.5873L7.36396 18.0003L1 11.6363L2.41421 10.2221L3.82723 11.6352L3.82604 11.6363L8.77698 16.5873Z"
                          ></path>
                        </svg>
                        <span className="font-semibold text-black dark:text-white">
                          99.99%
                        </span>{" "}
                        Uptime Guarantee
                      </p>
                      <p className="flex items-center gap-2 mt-0 text-muted dark:text-darkmuted">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          className="w-5 h-5 text-purple"
                        >
                          <path
                            fill="currentColor"
                            d="M11.602 13.7599L13.014 15.1719L21.4795 6.7063L22.8938 8.12051L13.014 18.0003L6.65 11.6363L8.06421 10.2221L10.189 12.3469L11.6025 13.7594L11.602 13.7599ZM11.6037 10.9322L16.5563 5.97949L17.9666 7.38977L13.014 12.3424L11.6037 10.9322ZM8.77698 16.5873L7.36396 18.0003L1 11.6363L2.41421 10.2221L3.82723 11.6352L3.82604 11.6363L8.77698 16.5873Z"
                          ></path>
                        </svg>
                        <span className="font-semibold text-black dark:text-white">
                          6 Months
                        </span>{" "}
                        Support
                      </p>
                      <p className="flex items-center gap-2 mt-0 text-muted dark:text-darkmuted">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          className="w-5 h-5 text-purple"
                        >
                          <path
                            fill="currentColor"
                            d="M11.602 13.7599L13.014 15.1719L21.4795 6.7063L22.8938 8.12051L13.014 18.0003L6.65 11.6363L8.06421 10.2221L10.189 12.3469L11.6025 13.7594L11.602 13.7599ZM11.6037 10.9322L16.5563 5.97949L17.9666 7.38977L13.014 12.3424L11.6037 10.9322ZM8.77698 16.5873L7.36396 18.0003L1 11.6363L2.41421 10.2221L3.82723 11.6352L3.82604 11.6363L8.77698 16.5873Z"
                          ></path>
                        </svg>
                        Enterprise SLA
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Pricing;
